import { apiClient } from './apiClient';
import { Watermark } from '@/types/model';

export interface WatermarkPayload {
  name: string;
  imageUrl: string;
}

export const watermarkService = {
  async getWatermarks(): Promise<{ success: boolean; watermarks: Watermark[] }> {
    return apiClient.get('/watermarks');
  },

  async createWatermark(payload: WatermarkPayload): Promise<{ success: boolean; watermark: Watermark }> {
    return apiClient.post('/watermarks', payload);
  },
};
